module.exports = __webpack_public_path__ + "ea7219152122a68507577626b9882e51.svg";